<div class="nav-cont">

  <nav style="width: 100%;" class="pad flex">
    <div class="" style="width: 100%">
      <!-- <figure>
            <h2>Travels</h2>
        </figure> -->
      <a routerLink="splash">
        <img height="25" src="https://customerdocument.blob.core.windows.net/customerdocuments/logo-1.png" alt="Travels" />
      </a>
    </div>
    <div class="flex profile" *ngIf="!isHomeRoute">
      <div>
        <a routerLink="main/profile" class="flex">
          <mat-icon style="color: red;">account_circle</mat-icon>
          <p style="flex: 4; padding: 0 5rem 0 0; text-wrap: nowrap">
            {{ user["name"] | titlecase }}
          </p>
        </a>
      </div>

      <div *ngIf="walBalance" class="top-bal">
        <h4 class="bal">
          <div class="flex">
            <mat-icon style="color: #000">account_balance_wallet</mat-icon>
            <span *ngIf="hide">
              {{ walletBalance["balance"] | currency : "₦ " }}</span>
          </div>
        </h4>
      </div>

      <div *ngIf="unitBalance" class="top-bal">
        <h4 class="bal">
          <div class="flex">
            <img src="../../assets/unit-icon-3.svg" alt="">
            <span *ngIf="hide">
              {{ user["units"] | currency : "₦ "}}</span>
          </div>
        </h4>
      </div>

      <div id="eye">
        <mat-icon (click)="eye()">
          {{ hide ? "visibility_off" : "visibility" }}
        </mat-icon>
      </div>
    </div>
    <div>
      <div>
        <a routerLink="get-qoute" *ngIf="isHomeRoute" mat-raised-button color="accent"><span> Get a Quote </span>
          <mat-icon>arrow_right_alt</mat-icon> </a>
      </div>
    </div>
  </nav>
</div>